import { data } from "../../data/super-region-to-country-code.js";
export function getSuperRegion(countryCode, language = "en") {
    var _a, _b;
    for (const superRegionCode in data) {
        const { name, parts } = data[superRegionCode];
        if (parts && parts.includes(countryCode)) {
            return {
                code: superRegionCode,
                label: (_a = name[language]) !== null && _a !== void 0 ? _a : name["en"],
            };
        }
    }
    const otherName = data.OTHER.name;
    return {
        code: "OTHER",
        label: (_b = otherName[language]) !== null && _b !== void 0 ? _b : otherName["en"],
    };
}
